import { render } from "./CustomAccountManagement.vue.vue?vue&type=template&id=2b734cdd&scoped=true"
import script from "./CustomAccountManagement.vue.vue?vue&type=script&lang=js"
export * from "./CustomAccountManagement.vue.vue?vue&type=script&lang=js"

import "./CustomAccountManagement.vue.vue?vue&type=style&index=0&id=2b734cdd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b734cdd"],['__file',"src/views/CustomAccountManagement/CustomAccountManagement.vue.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2b734cdd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2b734cdd', __exports__)) {
    api.reload('2b734cdd', __exports__)
  }
  
  module.hot.accept("./CustomAccountManagement.vue.vue?vue&type=template&id=2b734cdd&scoped=true", () => {
    api.rerender('2b734cdd', render)
  })

}


export default __exports__